import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  newTab = true;

  constructor() { }

  public download(res:Blob){
    let contentType = res.type;
    let blob = new Blob([res], { type: "application/pdf" });
    let url = window.URL.createObjectURL(blob);

    window.open(url, '_blank', '');
    let anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = "DirectAssessment.pdf";

    if (this.newTab) {
      anchor.target = '_blank';
    }
    anchor.click();
      anchor.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

    setTimeout(function () {
      window.URL.revokeObjectURL(url);
      anchor.remove();
    }, 10);
  }
}
